import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { DashboardLayout } from '../../../layout';
import { DocumentTitle, urlHelper } from '../../../../helpers';
import { Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import moment from 'moment-timezone';
import { notificationActions } from '../../../../common/redux/actions';
class Notifications extends Component {

    constructor(props) {
        super(props);
        this.page = 1;
    }
    
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(notificationActions.notification());
    }

    delete = (item) => {
        const { dispatch } = this.props;
        dispatch(notificationActions.notification("DELETE", {selection: item.message_id}));
    }

    loadMore = () => {
        const { dispatch } = this.props;
        this.page = this.page + 1;
        dispatch(notificationActions.notification("GET", null, {page: this.page}, 'load-more'));
    }

    read = (item) => {
        const { dispatch } = this.props;
        dispatch(notificationActions.notification("POST", {selection: item.message_id}));
    }

    render() {
        const { notifications } = this.props;
        const items = (notifications && notifications.notifications) ? notifications.notifications : null;
        const pagination = (notifications && notifications.pagination) ? notifications.pagination : null;
        //console.log('products', items);
        return (<DashboardLayout>
            <DocumentTitle title={`Notifications`}/>
            <section className="notifications">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Notification</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="list-group">
                            {(items === null) ? <>
                                {[1,2,3].map((item) =>
                                    <li className="list-group-item d-flex flex-wrap justify-content-between" key={`loading-${item}`}>
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                    </li>
                                )}
                            </> : <>
                            {items && items.map((item) =>
                                <li className={`list-group-item d-flex flex-wrap justify-content-between ${item.seen ? 'bg-light' : ''}`} key={`item-${item.message_id}`}>
                                    <h5><Link to={urlHelper.notifyUrl(item)} onClick={() => this.read(item)}> {item.notification}</Link></h5>
                                    <p className="mb-0">
                                        <span>{moment(item.created_at * 1000).format('LL')}</span>
                                        <button className="btn bg-primary rounded-circle px-2 py-1" onClick={() => this.delete(item)}><img width="15px" src="/images/svg/trash.svg"/></button>
                                    </p>
                                </li>
                            )}
                            {(items && items.length === 0) &&
                                <li className="list-group-item">Notification not found</li>
                            }
                            </>}
                        </ul>  
                        {pagination && pagination.totalCount > 19 && <>
                            <div className="list-group-item d-flex flex-wrap justify-content-center">
                                <button className="btn bg-primary" onClick={this.loadMore}>Load More {notifications.loading && <span className="spinner-border spinner-border-sm"></span>}</button>
                            </div>
                        </>}
                    </div>
                </div>
            </section>
            </DashboardLayout>);
    }
}

const authSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const notificationSelector = createSelector(
    state => state.notifications,
    notifications => notifications
);

const mapStateToProps = createSelector(
    authSelector, notificationSelector,
    (authentication, notifications) => ({
        authentication, notifications
    })
);

export default connect(mapStateToProps)(Notifications);